import type {ReactElement} from 'react';
import {Dropdown} from '@Components/dropdown-v2';
import {ALIGNMENT_TYPE, DROPDOWN_POSITION} from '@Components/dropdown-v2/dropdown.types';
import {ControlledList} from '@Components/controlled-list';
import type {ControlledListItemType} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE, ControlledListItemSize} from '@Components/controlled-list/controlled-list.types';
import {ColorTypes} from '@Components/controlled-list/components/controlled-list-item-type-7';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import type {FolderCardMoreOptionsProps} from './folder-card-more-options.types';
import styles from './folder-card-more-options.module.scss';

export function FolderCardMoreOptions({isShared, onShare, onRename, onDelete, onRemoveShared, onOpenChange}: FolderCardMoreOptionsProps): ReactElement {
  const getDeleteOption = (): ControlledListItemType => {
    return {
      id: 'collection-option-delete',
      text: window.i18next.t('pmwjs_delete'),
      type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
      color: ColorTypes.danger,
      textClasses: styles.deleteOptionText,
      icon: 'icon-delete',
      listSize: ControlledListItemSize.SMALL,
      onClick: isShared ? onRemoveShared : onDelete,
    };
  };

  const getMenuItems = (): ControlledListItemType[] => {
    if (isShared) {
      return [getDeleteOption()];
    }
    return [
      {
        id: 'collection-option-share',
        text: window.i18next.t('pmwjs_share'),
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
        icon: 'icon-group-add',
        listSize: ControlledListItemSize.SMALL,
        onClick: onShare,
      },
      {
        id: 'collection-option-edit',
        text: window.i18next.t('pmwjs_rename'),
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
        icon: 'icon-pencil-line',
        listSize: ControlledListItemSize.SMALL,
        onClick: onRename,
      },
      getDeleteOption(),
    ];
  };

  return (
    <Dropdown
      selector={<Icon icon="icon-menu-dots" size={IconSize.SIZE_ICON_16} shape={IconShape.SQUARE} type={IconType.GHOST} />}
      popup={<ControlledList id="collections-option-dropdown" className="spacing-m-0" items={getMenuItems()} />}
      position={DROPDOWN_POSITION.ABSOLUTE}
      popupClassName={styles.moreOptionsDropdownPopup}
      popupSpacingClass="spacing-p-2"
      popUpHasCustomWidth
      alignment={ALIGNMENT_TYPE.BOTTOM_END}
      onOpen={(): void => {
        onOpenChange?.(true);
      }}
      onClose={(): void => {
        onOpenChange?.(false);
      }}
    />
  );
}
